module.exports = __webpack_public_path__ + "img/Copper.b0ee1cbf.svg";